import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AddEmailToMailingListService {
  private httpClient = inject(HttpClient);

  addEmail(payload: { email: string; mailingListId: string }) {
    return this.httpClient.post(
      `${CASPER_BASE_API_URL}/webhook/api/newsletter/add-email`,
      {
        email: payload.email,
        mailingListId: payload.mailingListId,
      },
    );
  }
}
